import Model from 'models/Model';
import MediaFile from '../mediaFile/Model.MediaFile';
import ProviderStatementEmailTemplate from '../providerStatementEmailTemplate/Model.ProviderStatementEmailTemplate';

export default class ProviderStatementEmailTemplateAttachment
  extends Model<Model.IProviderStatementEmailTemplateAttachment>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProviderStatementEmailTemplateAttachment>
{
  id: number;
  languageIsoCode: Locale.Languages;
  providerStatementEmailTemplate: ProviderStatementEmailTemplate;
  providerStatementEmailTemplateId: number;
  mediaFile: MediaFile;
  mediaFileId: number;

  constructor(
    data:
      | Partial<Model.IProviderStatementEmailTemplateAttachment>
      | Utils.FormData<Model.IProviderStatementEmailTemplateAttachment>,
    language?: Locale.Languages
  ) {
    super(
      {
        providerStatementEmailTemplate: ProviderStatementEmailTemplate,
        mediaFile: MediaFile,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }
}
